import type { Link } from "../../aysa_api/models/link.types";
import { Reader, Writer } from "protobufjs/minimal";
import {
  createBaseLinkTarget,
  encodeLinkTarget,
  decodeLinkTarget,
} from "../../aysa_api/models/link_target";

export const createBaseLink = (): Link => {
  return {
    label: "",
    linkTarget: createBaseLinkTarget(),
  };
};

export const decodeLink = (reader: Reader, length: number): Link => {
  const end = reader.pos + length;
  const message = createBaseLink();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.label = reader.string();

        break;
      case 2:
        message.linkTarget = decodeLinkTarget(reader, reader.uint32());

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeLink = (writer: Writer, message: Link): Writer => {
  writer.uint32(10).string(message.label);
  encodeLinkTarget(writer.uint32(18).fork(), message.linkTarget).ldelim();

  return writer;
};
